// import React, { useState } from 'react'
// import { LiaSlidersHSolid } from "react-icons/lia";
// import { FaTableList } from "react-icons/fa6";
// import { MdPhoneAndroid } from "react-icons/md";
// import { FaRegHandPointLeft } from "react-icons/fa6";



// import notemplate from '../images/notemplate.png'


// function TemplateInformation({ setTemplateimformatios }) {
//     const [send, setsend] = useState(false)
//     console.log("setTemplateimformatios ",setTemplateimformatios)
//     return (
//         <>
//             <div className='w-[100%] shadow-[0px_5px_15px_0px_rgba(0,0,0,0.15)] p-3 md:p-4 rounded-md mt-4'>

//                 <div className='w-[100%] border-b-[1px] border-[#dfdfdf] pb-1 flex items-center gap-1'>
//                     <p className='text-[#121519] font-semibold text-[16px] md:text-[18px] dark:text-[#fff]'>
//                         Template Information 📲
//                     </p>
//                 </div>
//                 <div className='flex flex-wrap w-[100%] justify-between mt-4 '>
//                     <div className='sm:w-[32%] w-[100%]'>

//                         <p className='flex items-center text-[13px] font-[500] gap-1 dark:text-[#fff]'>
//                             <LiaSlidersHSolid /> Template Category  <span className='text-red-600'>*</span>
//                         </p>
//                         <p className='text-[12px] text-[#808080] dark:text-[#fff]'>
//                             Select your template category
//                         </p>
//                         <select name="" id=""
//                             className="border border-[#d4cfcf] text-[#454546] font-medium bg-white dark:border-[#251f1f] dark:text-[#e2dbdb] w-[100%]  p-2 rounded-md text-[13px] mt-1 outline-none dark:bg-[#121519] "
//                         >
//                             <option value="">Select Category</option>
//                             <option value="Marketing">Marketing</option>
//                             <option value="Utility">Utility</option>
//                             <option value="Authentication">Authentication</option>
//                         </select>

//                     </div>
//                     <div className='sm:w-[32%] w-[100%]'>

//                         <p className='flex items-center text-[13px] font-[500] gap-1 dark:text-[#fff]'>
//                             <FaTableList /> Template Type  <span className='text-red-600'>*</span>
//                         </p>
//                         <p className='text-[12px] text-[#808080] dark:text-[#fff]'>
//                             Select your template type
//                         </p>
//                         <select name="" id=""
//                             className="border border-[#d4cfcf] text-[#454546] font-medium bg-white dark:border-[#251f1f] dark:text-[#e2dbdb] w-[100%]  p-2 rounded-md text-[13px] mt-1 outline-none dark:bg-[#121519] "
//                         >
//                             <option value="All">All</option>
//                             <option value="Default">Default</option>
//                             <option value="Flows">Flows</option>
//                             <option value="LimitedTimeOffer">LimitedTimeOffer</option>
//                             <option value="Carousel">Carousel</option>
//                         </select>

//                     </div>
//                     <div className='sm:w-[32%] w-[100%]'>

//                         <p className='flex items-center text-[13px] font-[500] gap-1 dark:text-[#fff]'>
//                             <MdPhoneAndroid /> Meta Template <span className='text-red-600'>*</span>
//                         </p>
//                         <p className='text-[12px] text-[#808080] dark:text-[#fff]'>
//                             Your WhatsApp approved templates
//                         </p>
//                         <select name="" id=""
//                             className="border border-[#d4cfcf] text-[#454546] font-medium bg-white dark:border-[#251f1f] dark:text-[#e2dbdb] w-[100%]  p-2 rounded-md text-[13px] mt-1 outline-none dark:bg-[#121519] "
//                         >
//                             <option value="">Select Template</option>

//                         </select>

//                     </div>
//                 </div>
//                 <div className='w-[100%] flex justify-center items-center '>
//                     <img
//                         className='w-[200px]'
//                         src={notemplate} alt="" />
//                 </div>
//                 <div className='w-[100%] flex justify-end gap-1'>
//                     <button
//                         onClick={() => setTemplateimformatios(false)}
//                         className='hover:bg-[#d3dde6] bg-[#edf1f5] text-[#434a57] hover:text-[#000] p-2 rounded-md text-[13px] font-semibold flex items-center'>
//                         <FaRegHandPointLeft />
//                         Previous
//                     </button>
//                     <button

//                         disabled={!send}
//                         className={`flex items-center border-[1px] rounded-lg px-4 py-2 gap-2 text-[12px] font-bold w-full md:w-auto justify-center
//     ${!send
//                                 ? 'bg-[#37715d]/50  text-white cursor-not-allowed'
//                                 : 'bg-[#37715d] border-[#37715d] text-white hover:bg-[#2f5e4e]'
//                             }`}
//                     >
//                         Next
//                     </button>
//                 </div>
//             </div>
//         </>
//     )
// }

// export default TemplateInformation
import React, { useState, useEffect } from 'react'
import { LiaSlidersHSolid } from "react-icons/lia";
import { FaTableList } from "react-icons/fa6";
import { MdPhoneAndroid } from "react-icons/md";
import { FaRegHandPointLeft } from "react-icons/fa6";
import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL || "https://wa-api.globebot.io";

// Extract {{1}}, {{2}} etc. from a string, returns sorted unique numbers
function extractVarNumbers(text) {
    if (!text) return [];
    const matches = text.match(/{{\d+}}/g) || [];
    const nums = [...new Set(matches.map(m => parseInt(m.replace(/[{}]/g, ''))))];
    return nums.sort((a, b) => a - b);
}

// Replace {{1}} with actual values for preview
function fillPreview(text, variables) {
    if (!text) return '';
    return text.replace(/{{\d+}}/g, (match) => {
        const idx = parseInt(match.replace(/[{}]/g, '')) - 1;
        return variables[idx] || match;
    });
}

function TemplateInformation({ templateData, setTemplateData, campaignData, token, onNext, onPrev }) {
    const [templates,        setTemplates]        = useState([]);
    const [loadingTemplates, setLoadingTemplates] = useState(false);
    const [templateError,    setTemplateError]    = useState(null);

    // ── Fetch approved templates ──────────────────────────────────────────
    useEffect(() => {
        if (!campaignData?.phoneNumberId) return;
        fetchTemplates();
        // eslint-disable-next-line
    }, [campaignData?.phoneNumberId]);

    const fetchTemplates = async () => {
        setLoadingTemplates(true);
        setTemplateError(null);
        try {
            const headers = token ? { Authorization: token } : {};
            const res = await axios.get(
                `${API_URL}/auth/whatsapp/meta_templates/full?waba_id=${encodeURIComponent(campaignData.wabaId)}`,
                { headers }
            );
            const data = Array.isArray(res.data) ? res.data : [];
            setTemplates(data);
            if (data.length === 0) setTemplateError("No approved templates found for this channel.");
        } catch {
            setTemplateError("Failed to load templates. Please try again.");
            setTemplates([]);
        } finally {
            setLoadingTemplates(false);
        }
    };

    // ── Filter by category + type ─────────────────────────────────────────
    const filteredTemplates = templates.filter(t => {
        const catMatch  = !templateData.category || templateData.category === ''
            || t.category?.toLowerCase() === templateData.category.toLowerCase();
        const typeMatch = !templateData.templateType || templateData.templateType === 'All'
            || t.sub_category?.toLowerCase() === templateData.templateType.toLowerCase();
        return catMatch && typeMatch;
    });

    // ── On template select ────────────────────────────────────────────────
    const handleSelectTemplate = (tpl) => {
        const bodyText   = tpl.components?.find(c => c.type === 'BODY')?.text   || '';
        const headerText = tpl.components?.find(c => c.type === 'HEADER')?.text || '';

        // Collect all unique variable numbers across body + header
        const bodyVarNums   = extractVarNumbers(bodyText);
        const headerVarNums = extractVarNumbers(headerText);
        const allVarNums    = [...new Set([...headerVarNums, ...bodyVarNums])].sort((a,b) => a-b);

        setTemplateData(prev => ({
            ...prev,
            templateName:   tpl.name,
            language:       tpl.language || 'en',
            components:     tpl.components || [],
            // variables: string[] indexed by {{n}}-1
            // Pre-fill with empty strings for each placeholder
            variables:      Array(Math.max(0, ...allVarNums)).fill(''),
            // Store which sections have variables for UI rendering
            bodyVarNums,
            headerVarNums,
            allVarNums,
        }));
    };

    // ── Update a single variable value ────────────────────────────────────
    const handleVarChange = (index, value) => {
        setTemplateData(prev => {
            const vars = [...(prev.variables || [])];
            vars[index] = value;
            return { ...prev, variables: vars };
        });
    };

    // ── Derived ───────────────────────────────────────────────────────────
    const bodyText      = templateData.components?.find(c => c.type === 'BODY')?.text   || '';
    const headerText    = templateData.components?.find(c => c.type === 'HEADER')?.text || '';
    const footerText    = templateData.components?.find(c => c.type === 'FOOTER')?.text || '';
    const buttons       = templateData.components?.find(c => c.type === 'BUTTONS')?.buttons || [];
    const allVarNums    = templateData.allVarNums   || [];
    const variables     = templateData.variables    || [];

    // All required variables must be filled before proceeding
    const allVarsFilled = allVarNums.every(n => (variables[n - 1] || '').trim() !== '');
    const canProceed    = !!templateData.templateName && allVarsFilled;

    return (
        <div className='w-[100%] shadow-[0px_5px_15px_0px_rgba(0,0,0,0.15)] p-3 md:p-4 rounded-md mt-4'>
            <div className='w-[100%] border-b-[1px] border-[#dfdfdf] pb-1 flex items-center gap-1 mb-4'>
                <p className='text-[#121519] font-semibold text-[16px] md:text-[18px] dark:text-[#fff]'>
                    Template Information 📲
                </p>
            </div>

            {/* ── Filters row ── */}
            <div className='flex flex-wrap w-[100%] justify-between gap-3'>

                {/* Category */}
                <div className='sm:w-[32%] w-[100%]'>
                    <p className='flex items-center text-[13px] font-[500] gap-1 dark:text-[#fff]'>
                        <LiaSlidersHSolid /> Template Category <span className='text-red-600'>*</span>
                    </p>
                    <p className='text-[12px] text-[#808080] dark:text-[#fff]'>Filter by category</p>
                    <select
                        value={templateData.category}
                        onChange={(e) => setTemplateData(prev => ({
                            ...prev, category: e.target.value,
                            templateName: '', components: [], variables: [], allVarNums: []
                        }))}
                        className="border border-[#d4cfcf] text-[#454546] font-medium bg-white dark:border-[#251f1f] dark:text-[#e2dbdb] w-[100%] p-2 rounded-md text-[13px] mt-1 outline-none dark:bg-[#121519]"
                    >
                        <option value="">All Categories</option>
                        <option value="MARKETING">Marketing</option>
                        <option value="UTILITY">Utility</option>
                        <option value="AUTHENTICATION">Authentication</option>
                    </select>
                </div>

                {/* Type */}
                <div className='sm:w-[32%] w-[100%]'>
                    <p className='flex items-center text-[13px] font-[500] gap-1 dark:text-[#fff]'>
                        <FaTableList /> Template Type <span className='text-red-600'>*</span>
                    </p>
                    <p className='text-[12px] text-[#808080] dark:text-[#fff]'>Filter by type</p>
                    <select
                        value={templateData.templateType}
                        onChange={(e) => setTemplateData(prev => ({
                            ...prev, templateType: e.target.value,
                            templateName: '', components: [], variables: [], allVarNums: []
                        }))}
                        className="border border-[#d4cfcf] text-[#454546] font-medium bg-white dark:border-[#251f1f] dark:text-[#e2dbdb] w-[100%] p-2 rounded-md text-[13px] mt-1 outline-none dark:bg-[#121519]"
                    >
                        <option value="All">All</option>
                        <option value="Default">Default</option>
                        <option value="Flows">Flows</option>
                        <option value="LimitedTimeOffer">LimitedTimeOffer</option>
                        <option value="Carousel">Carousel</option>
                    </select>
                </div>

                {/* Template picker */}
                <div className='sm:w-[32%] w-[100%]'>
                    <p className='flex items-center text-[13px] font-[500] gap-1 dark:text-[#fff]'>
                        <MdPhoneAndroid /> Meta Template <span className='text-red-600'>*</span>
                    </p>
                    <p className='text-[12px] text-[#808080] dark:text-[#fff]'>Your approved templates</p>
                    <select
                        value={templateData.templateName}
                        onChange={(e) => {
                            const chosen = filteredTemplates.find(t => t.name === e.target.value);
                            if (chosen) handleSelectTemplate(chosen);
                            else setTemplateData(prev => ({
                                ...prev, templateName: '', components: [],
                                variables: [], allVarNums: []
                            }));
                        }}
                        disabled={loadingTemplates || filteredTemplates.length === 0}
                        className="border border-[#d4cfcf] text-[#454546] font-medium bg-white dark:border-[#251f1f] dark:text-[#e2dbdb] w-[100%] p-2 rounded-md text-[13px] mt-1 outline-none dark:bg-[#121519] disabled:opacity-60"
                    >
                        <option value="">
                            {loadingTemplates ? 'Loading...'
                             : filteredTemplates.length === 0 ? 'No templates found'
                             : 'Select Template'}
                        </option>
                        {filteredTemplates.map(t => (
                            <option key={t.name + t.language} value={t.name}>
                                {t.name} ({t.language})
                            </option>
                        ))}
                    </select>
                </div>
            </div>

            {/* ── Error ── */}
            {templateError && (
                <div className='mt-3 p-3 bg-[#fff0f0] border border-[#fca5a5] rounded-lg text-[#991b1b] text-[12px] font-semibold'>
                    ⚠️ {templateError}
                    <button onClick={fetchTemplates} className='ml-2 underline'>Retry</button>
                </div>
            )}

            {loadingTemplates && (
                <div className='flex justify-center items-center py-8'>
                    <div className='animate-spin w-8 h-8 border-4 border-[#ed7b00] border-t-transparent rounded-full'></div>
                    <span className='ml-3 text-[13px] text-[#808080]'>Loading templates...</span>
                </div>
            )}

            {/* ══════════════════════════════════════════════════════════════
                VARIABLE INPUTS — shown only when template has {{n}} placeholders
            ══════════════════════════════════════════════════════════════ */}
            {templateData.templateName && allVarNums.length > 0 && (
                <div className='mt-5 p-4 border border-[#f59e0b] bg-[#fffbe6] rounded-lg'>
                    <p className='text-[14px] font-bold text-[#856404] mb-1'>
                        📝 Template Variables Required
                    </p>
                    <p className='text-[12px] text-[#856404] mb-3'>
                        This template has <strong>{allVarNums.length}</strong> variable{allVarNums.length > 1 ? 's' : ''}.
                        These values will be sent to <strong>every recipient</strong> in the campaign.
                        If each recipient needs a different value (e.g. their name), upload a CSV instead.
                    </p>

                    <div className='flex flex-wrap gap-3'>
                        {allVarNums.map(n => {
                            // Find which part of the template this variable appears in
                            const inHeader = (templateData.headerVarNums || []).includes(n);
                            const inBody   = (templateData.bodyVarNums   || []).includes(n);
                            const context  = inHeader && inBody ? 'Header & Body'
                                           : inHeader ? 'Header' : 'Body';

                            // Show the surrounding text for context
                            const contextText = inHeader ? headerText : bodyText;
                            const snippet = contextText
                                ? contextText.replace(new RegExp(`{{${n}}}`, 'g'), `[→ {{${n}}} ←]`)
                                : '';

                            return (
                                <div key={n} className='w-full sm:w-[48%]'>
                                    <label className='text-[12px] font-semibold text-[#374151] mb-1 block'>
                                        Variable <code className='bg-[#fef3c7] px-1 rounded text-[#92400e]'>{`{{${n}}}`}</code>
                                        <span className='ml-2 text-[10px] text-[#808080] font-normal'>used in {context}</span>
                                    </label>
                                    {snippet && (
                                        <p className='text-[10px] text-[#808080] mb-1 italic line-clamp-1'>
                                            e.g: "{snippet.replace(/\[→ /g,'').replace(/ ←\]/g,'')}"
                                        </p>
                                    )}
                                    <input
                                        type="text"
                                        placeholder={`Enter value for {{${n}}}`}
                                        value={variables[n - 1] || ''}
                                        onChange={(e) => handleVarChange(n - 1, e.target.value)}
                                        className={`w-full border rounded-md p-2 text-[13px] outline-none transition-colors
                                            ${!(variables[n - 1] || '').trim()
                                                ? 'border-[#f59e0b] bg-white'
                                                : 'border-[#6ee7b7] bg-[#f0faf8]'
                                            }`}
                                    />
                                    {!(variables[n - 1] || '').trim() && (
                                        <p className='text-[11px] text-[#ef4444] mt-0.5'>Required</p>
                                    )}
                                </div>
                            );
                        })}
                    </div>
                </div>
            )}

            {/* ── Template has NO variables — green confirmation ── */}
            {templateData.templateName && allVarNums.length === 0 && (
                <div className='mt-4 p-3 bg-[#f0faf8] border border-[#6ee7b7] rounded-lg'>
                    <p className='text-[13px] font-bold text-[#065f46] mb-1'>
                        ✅ No variables — static template
                    </p>
                    <p className='text-[12px] text-[#374151]'>
                        This template has no placeholders. The same message will be sent to all recipients as-is.
                    </p>
                </div>
            )}

            {/* ── Live preview with filled variables ── */}
            {templateData.templateName && (
                <div className='mt-4 p-3 bg-[#f9fafb] border border-[#e5e7eb] rounded-lg'>
                    <p className='text-[12px] font-bold text-[#374151] mb-2 flex items-center gap-1'>
                        👁 Message Preview
                        {allVarNums.length > 0 && (
                            <span className='text-[10px] font-normal text-[#808080]'>
                                (showing with your variable values)
                            </span>
                        )}
                    </p>

                    {/* Header preview */}
                    {headerText && (
                        <p className='text-[13px] font-bold text-[#1a1919] mb-1'>
                            {fillPreview(headerText, variables)}
                        </p>
                    )}

                    {/* Body preview */}
                    {bodyText && (
                        <p className='text-[12px] text-[#374151] whitespace-pre-line'>
                            {fillPreview(bodyText, variables)}
                        </p>
                    )}

                    {/* Footer preview */}
                    {footerText && (
                        <p className='text-[11px] text-[#808080] mt-1'>{footerText}</p>
                    )}

                    {/* Buttons preview */}
                    {buttons.length > 0 && (
                        <div className='flex flex-wrap gap-2 mt-2 pt-2 border-t border-[#e5e7eb]'>
                            {buttons.map((btn, i) => (
                                <span key={i} className='text-[11px] bg-[#d1fae5] text-[#065f46] px-2 py-0.5 rounded-full font-semibold'>
                                    {btn.type}: {btn.text}
                                </span>
                            ))}
                        </div>
                    )}

                    <p className='text-[10px] text-[#808080] mt-2'>
                        Language: {templateData.language} · Name: {templateData.templateName}
                    </p>
                </div>
            )}

            {/* ── Navigation ── */}
            <div className='w-[100%] flex justify-end gap-2 mt-6'>
                <button
                    onClick={onPrev}
                    className='hover:bg-[#d3dde6] bg-[#edf1f5] text-[#434a57] hover:text-[#000] p-2 rounded-md text-[13px] font-semibold flex items-center gap-1'
                >
                    <FaRegHandPointLeft /> Previous
                </button>
                <button
                    onClick={onNext}
                    disabled={!canProceed}
                    className={`flex items-center border-[1px] rounded-lg px-4 py-2 gap-2 text-[13px] font-bold
                        ${!canProceed
                            ? 'bg-[#37715d]/50 border-transparent text-white cursor-not-allowed'
                            : 'bg-[#37715d] border-[#37715d] text-white hover:bg-[#2f5e4e]'
                        }`}
                >
                    Next →
                </button>
            </div>
        </div>
    );
}

export default TemplateInformation;